/**
 * AUREXIS COMMAND LAYOUT
 * Main application shell — slim rail sidebar + header
 */
import { ReactNode } from 'react';
import { CommandSidebar } from '@/components/CommandSidebar';
import { CommandHeader } from '@/components/CommandHeader';

interface CommandLayoutProps {
  children: ReactNode;
  systemMode?: 'idle' | 'training' | 'autonomous';
}

export default function CommandLayout({ children, systemMode = 'idle' }: CommandLayoutProps) {
  return (
    <div className="aurexis-app">
      <CommandSidebar systemMode={systemMode} />
      <CommandHeader isCollapsed={false} />
      <main className="aurexis-main mil-scroll">
        {children}
      </main>
    </div>
  );
}

export { CommandLayout };
